import type { Fetcher } from "react-query-kit";
import { createQuery } from "react-query-kit";

import { getApi } from "@api/apiPath";
import type { IFile } from "@api/file/routeType";
import type { IPickSingleQuery } from "@/api";
import { axiosClient } from "@api/clients.ts";

const { key, getPath } = getApi("file.get");

type IExtractedRouteType = IFile["fileSingleRetrieve"];

export type IGetFile = IPickSingleQuery<IExtractedRouteType>;

const getFile: Fetcher<IGetFile["response"], IGetFile["variables"]> = ({
  fileId,
  ...params
}) => {
  return axiosClient.get(getPath({ fileId }), { params });
};

export const useGetFile = createQuery({
  queryKey: [key],
  fetcher: getFile,
});
